import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import * as actions from 'actions/shared/index/filter';
import Crumb from './Crumb';

class Breadcrumbs extends Component {
  buildPath(rootNode, id) {
    const pathWithoutRoot = this.traverseTree(rootNode, id);

    if (pathWithoutRoot) {
      return [rootNode, ...pathWithoutRoot];
    }

    return [];
  }

  traverseTree(group, id) {
    if (group.id && group.id === id) {
      return [];
    }
    if (group.children) {
      for (let i = 0; i < group.children.length; i += 1) {
        const path = this.traverseTree(group.children[i], id);

        if (path !== null) {
          path.unshift(group.children[i]);
          return path;
        }
      }
    }

    return null;
  }

  renderGroupNames = path =>
    path.map((group, index, groups) => {
      if (groups.length - 1 !== index) {
        return (
          <Fragment key={group.id}>
            <Crumb
              group={group}
              updateActiveGroup={this.props.updateActiveGroup}
              updateMyOrganization={this.props.updateMyOrganization}
            />
            <Icon name="chevron_right" className="Icon--small ml-8 mr-8 " />
          </Fragment>
        );
      }

      return (
        <Crumb
          key={group.id}
          group={group}
          updateActiveGroup={this.props.updateActiveGroup}
          updateMyOrganization={this.props.updateMyOrganization}
        />
      );
    });

  render() {
    const { updateActiveGroup, updateMyOrganization } = this.props;
    const activeGroupId = Number(this.props.activeGroup);
    const path = this.props.organization
      .map(rootNode => this.buildPath(rootNode, activeGroupId))
      .filter(potentialPath => potentialPath.length)[0];

    return (
      <div className="mb-16">
        <Crumb
          group={null}
          updateActiveGroup={updateActiveGroup}
          updateMyOrganization={updateMyOrganization}
        />
        <Icon name="chevron_right" className="Icon--small ml-8 mr-8 " />
        {this.renderGroupNames(path)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  organization: state.data.meta.organization,
  activeGroup: state.filter.activeGroup,
});

const mapDispatchToProps = dispatch => ({
  updateActiveGroup(group) {
    dispatch(actions.filterUpdateActiveGroup(group));
  },
  updateMyOrganization(showMyOrganization) {
    dispatch(actions.filterUpdateMyOrganization(showMyOrganization));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
